// extracted by mini-css-extract-plugin
export default {"cards":"styles_cards__E1o-z","container":"styles_container__-FCHe","title":"styles_title__wS4p6","decor":"styles_decor__hrLYa","cardsWrapper":"styles_cardsWrapper__zVHaW"};